import { CSSProperties } from "react";
import { createStyledElement } from "../../utils/createStyledElement";
import { systemWhite, systemBlack, systemBlue } from "./constants";

const isMobileViewport = () =>
  typeof window !== "undefined" ? window.innerWidth <= 768 : false;

const baseButtonStyle: CSSProperties = {
  font: '700 12px/28px "Roboto", sans-serif',
  width: isMobileViewport() ? "100%" : 170,
  maxWidth: isMobileViewport() ? 340 : 170,
  borderRadius: 4,
  cursor: "pointer",
  padding: "9px 0",
  textAlign: "center",
  border: "none",
  appearance: "none",
  WebkitAppearance: "none",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  touchAction: "manipulation",
};

const sectionButtonStyle: CSSProperties = {
  width: isMobileViewport() ? "100%" : 225,
  maxWidth: isMobileViewport() ? 340 : 225,
  padding: "18px 0",
  font: '700 15px/22px "Roboto", sans-serif',
  borderRadius: 6,
};

export const SectionTitle = createStyledElement("span", () => ({
  font: isMobileViewport()
    ? '700 24px/29px "Roboto", sans-serif'
    : '700 40px/48px "Roboto", sans-serif',
  textAlign: "center",
  color: systemBlack,
}));

export const PrimaryButton = createStyledElement("button", {
  ...baseButtonStyle,
  color: systemWhite,
  backgroundColor: systemBlue,
});

export const SecondaryButton = createStyledElement("button", {
  ...baseButtonStyle,
  color: systemBlack,
  backgroundColor: systemWhite,
  border: `1px solid ${systemBlue}`,
});

export const SectionPrimaryButton = createStyledElement("button", {
  ...baseButtonStyle,
  ...sectionButtonStyle,
  color: systemWhite,
  backgroundColor: systemBlue,
});

export const SectionSecondaryButton = createStyledElement(
  "button",
  ({ $withBorder }) => ({
    ...baseButtonStyle,
    ...sectionButtonStyle,
    color: systemBlack,
    backgroundColor: systemWhite,
    border: $withBorder ? `1px solid ${systemBlue}` : "none",
  }),
  ["$withBorder"]
);

export const ButtonsContainer = createStyledElement(
  "div",
  ({ $withMargin, $shouldApplyColumnStyles, $align }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: $align ?? "flex-end",
    gap: 26,
    marginTop: $withMargin ? 40 : 0,
    width: "100%",
    flexWrap: isMobileViewport() ? "wrap" : "nowrap",
    flexDirection:
      isMobileViewport() && $shouldApplyColumnStyles ? "column" : "row",
  }),
  ["$withMargin", "$shouldApplyColumnStyles", "$align"]
);

export const Link = createStyledElement("a", {
  font: '400 16px/21px "Roboto", sans-serif',
  color: "#306BF5",
  textDecoration: "none",
});
